window._vue_richtext_widgets || (window._vue_richtext_widgets = {});
const _ = (e) => !!window._vue_richtext_widgets[e], c = (e) => {
  var t;
  return !!((t = window._vue_richtext_widgets[e]) != null && t.hasInteractiveView);
}, u = (e) => {
  var t;
  return !!((t = window._vue_richtext_widgets[e]) != null && t.fullWidth);
}, n = (e, t, r = (s) => {
}, i) => {
  const s = {
    hasInteractiveView: !0,
    fullWidth: !1,
    ...i
  };
  if (window._vue_richtext_widgets[e]) {
    console.error("Widget for id " + e + " already registered");
    return;
  }
  window._vue_richtext_widgets[e] = {
    id: e,
    callback: t,
    onDestroy: r,
    ...s
  };
}, w = (e, { richObjectType: t, richObject: r, accessible: i, interactive: s }) => {
  if (t !== "open-graph") {
    if (!window._vue_richtext_widgets[t]) {
      console.error("Widget for rich object type " + t + " not registered");
      return;
    }
    window._vue_richtext_widgets[t].callback(e, { richObjectType: t, richObject: r, accessible: i, interactive: s });
  }
}, l = (e, t) => {
  e !== "open-graph" && window._vue_richtext_widgets[e] && window._vue_richtext_widgets[e].onDestroy(t);
};
window._registerWidget = (e, t, r, i) => {
  n(e, t, r, i);
};
window._vue_richtext_custom_picker_elements || (window._vue_richtext_custom_picker_elements = {});
class d {
  /**
   * @param {HTMLElement} element The HTML element
   * @param {object} object The object
   */
  constructor(t, r) {
    this.element = t, this.object = r;
  }
}
const a = (e) => !!window._vue_richtext_custom_picker_elements[e], m = (e) => {
  var r;
  const t = (r = window._vue_richtext_custom_picker_elements[e]) == null ? void 0 : r.size;
  return ["small", "normal", "large", "full"].includes(t) ? t : null;
}, o = (e, t, r = (s) => {
}, i = "large") => {
  if (window._vue_richtext_custom_picker_elements[e]) {
    console.error("Custom reference picker element for id " + e + " already registered");
    return;
  }
  window._vue_richtext_custom_picker_elements[e] = {
    id: e,
    callback: t,
    onDestroy: r,
    size: i
  };
}, g = (e, { providerId: t, accessible: r }) => {
  if (!window._vue_richtext_custom_picker_elements[t]) {
    console.error("Custom reference picker element for reference provider ID " + t + " not registered");
    return;
  }
  return window._vue_richtext_custom_picker_elements[t].callback(e, { providerId: t, accessible: r });
}, h = (e, t, r) => {
  window._vue_richtext_custom_picker_elements[e] && window._vue_richtext_custom_picker_elements[e].onDestroy(t, r);
};
window._registerCustomPickerElement = o;
export {
  d as N,
  w as a,
  o as b,
  g as c,
  a as d,
  u as e,
  l as f,
  h as g,
  c as h,
  _ as i,
  m as j,
  n as r
};
